module.exports = __webpack_public_path__ + "img/hero-presents-collage-postcard@2x.898197a3.png";